
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3183',
  depVersions: {
  "customer-portal-app": "static-1.3183",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9998",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26270",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5936",
  "hs-test-utils": "static-1.8383",
  "hub-http": "static-1.6558",
  "hub-http-shared-msw-handlers": "static-1.10693",
  "hubspot-dlb": "static-2.1905",
  "hubspot-prosemirror": "static-1.19059",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11838",
  "I18n": "static-7.1680",
  "immutable": "static-2.87",
  "jasmine-runner": "static-1.6796",
  "payment-link-components": "static-1.24226",
  "portals-platform-bend-plugin": "static-1.23",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7513",
  "quartz-core": "static-1.6732",
  "quartz-i18n": "static-1.1188",
  "react": "static-7.196",
  "react-colorpicker": "static-2.10559",
  "react-dlb": "static-1.89",
  "react-utils": "static-2.5586",
  "reselect": "static-3.13",
  "rich-text-lib": "static-1.20368",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18437",
  "ui-components-test-utils": "static-1.5975",
  "UIComponents": "static-3.8784",
  "foundations-assets": "static-1.5232",
  "foundations-components": "static-1.8559",
  "foundations-theming": "static-1.4822",
  "foundations-theming-specialty": "static-1.2538",
  "framer-motion": "static-1.80",
  "metrics-js": "static-1.9963",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1504",
  "quartz-config": "static-1.1291",
  "quartz-routing": "static-1.943",
  "quick-fetch": "static-1.4158",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17070",
  "rpc-client-utils": "static-1.5012",
  "sanitize-text": "static-1.8503",
  "styled-components": "static-2.99",
  "tanstack-table": "static-1.62",
  "ui-addon-draggable": "static-3.5103",
  "ui-addon-react-router-dom": "static-1.9878",
  "usage-tracker": "static-1.7659",
  "usage-tracker-anonymous": "static-1.6076",
  "usage-tracker-core": "static-1.7509",
  "video-components-external": "static-1.12225",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3790",
  "quartz-webpack": "static-1.3737",
  "bend-plugin-quartz-routing": "static-1.591",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.90",
  "customer-data-objects": "static-1.8044",
  "frontend-preferences-client": "static-1.8265",
  "laboratory-lib": "static-3.7499",
  "onboarding-scopes": "static-1.6798",
  "seat-types-lib": "static-1.799",
  "ui-addon-opt": "static-4.8712",
  "HeadJS": "static-2.804",
  "hs-test-utils-bend-plugin": "static-1.3494",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "hs-locale-management": "static-1.325",
  "ts-schema": "static-1.4324",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8258",
  "content-media-capture": "static-1.5530",
  "cssUtils": "static-1.968",
  "customer-data-ui-utilities": "static-1.10177",
  "file-manager-components": "static-1.24598",
  "HubStyle": "static-2.12145",
  "knowledge-content-types": "static-1.8691",
  "PatternValidationJS": "static-1.3237",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.508",
  "ui-addon-emoji-picker": "static-1.10230",
  "ui-addon-i18n": "static-1.11492",
  "ui-business-units-lib": "static-1.9437",
  "ui-shepherd-react": "static-3.10616",
  "video-data-lib": "static-1.35883",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4658",
  "commerce-tours-lib": "static-1.6683",
  "customer-data-properties": "static-1.52711",
  "getting-started-shared-tasks": "static-1.19331",
  "growth-onboarding-reliability": "static-1.5426",
  "onboarding-tours": "static-1.17198",
  "reference-resolvers-lite": "static-1.8450",
  "sales-checkout-service-client": "static-1.3874",
  "ui-addon-iframeable": "static-1.9423",
  "user-context": "static-1.5467",
  "bender-build-tools": "static-1.3452",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.888",
  "hubspotter-http": "static-1.4894",
  "icons": "static-2.695",
  "mobile-manifest-mixins": "static-1.584",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.498",
  "quartz-auth": "static-1.1188",
  "quartz-head": "static-1.1178",
  "quartz-test": "static-1.1188",
  "quartz-tracking": "static-1.892",
  "trellis-components": "static-1.2766",
  "ui-fonts": "static-1.1100",
  "usage-tracker-container": "static-1.7649",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9771",
  "data-token-picker": "static-1.16947",
  "FileManagerLib": "static-1.40238",
  "property-translator": "static-1.5739",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6443",
  "SharedI18nStrings": "static-1.183",
  "foundations-components-test-utils": "static-1.6042",
  "react-create-root-preference": "static-1.79",
  "react-select-plus": "static-1.114",
  "react-virtualized": "static-2.108",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-components": "static-1.4828",
  "floating-ui": "static-1.64",
  "react-aria": "static-1.73",
  "trellis-assets": "static-1.2747",
  "bend-plugin-foundations-theming": "static-1.3305",
  "foundations-theming-base": "static-1.3807",
  "stylex": "static-1.42",
  "interframe": "static-3.5101",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6073",
  "opentelemetry-fe-types": "static-1.123",
  "web-vitals": "static-1.16",
  "bend-plugin-chirp-manifest": "static-1.422",
  "chirp-fetch": "static-1.2242",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4818",
  "react-flip-move": "static-1.79",
  "apollo-link-hub-http": "static-2.5003",
  "content-media-composition-data-lib": "static-1.13334",
  "content-media-compositions": "static-2.17341",
  "idb-keyval": "static-1.52",
  "immer": "static-1.102",
  "immerable": "static-1.4492",
  "magpie-lib": "static-1.5788",
  "magpie-types": "static-1.5248",
  "media-bridge-lib": "static-1.19465",
  "inbound-db-properties-service-client": "static-1.4078",
  "superstore": "static-1.5105",
  "feedback-loader": "static-1.29871",
  "ai-components-ui-library": "static-1.9807",
  "ui-addon-video-player": "static-1.9048",
  "ui-coaching-tips": "static-1.29388",
  "ContentUtils": "static-1.69211",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4771",
  "sassPrefix": "static-1.235",
  "react-dnd-compat": "static-1.4962",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1854",
  "copilot-toolkit": "static-1.11923",
  "atom": "static-1.5428",
  "avatar-components": "static-1.2828",
  "navigation-messaging": "static-1.8239",
  "redux-thunk": "static-2.81",
  "reference-resolvers": "static-1.8527",
  "commerce-products-lib": "static-1.10630",
  "crm-message-bus": "static-1.43856",
  "growth-data-modal": "static-1.5954",
  "hubspot-apollo-client": "static-1.5223",
  "onboarding-tours-client": "static-1.5413",
  "batch-promise": "static-1.1891",
  "calling-global-api": "static-1.65759",
  "calling-internal-common": "static-1.31668",
  "calling-lifecycle-internal": "static-1.67141",
  "calling-lifecycle-messages": "static-1.59435",
  "conditional-properties-service-client": "static-1.4047",
  "crm-index-visualization-core": "static-1.4594",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4378",
  "customer-data-objects-ui-components": "static-1.13377",
  "customer-data-properties-shared-msw-handlers": "static-1.10020",
  "customer-data-property-utils": "static-1.8444",
  "external-options-client-types": "static-1.4371",
  "formula-editor": "static-1.14831",
  "framework-data-schema-resolvers": "static-1.7239",
  "google-libphonenumber": "static-1.46",
  "hs-resources": "static-1.539",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4457",
  "meetings-icalendar-utils-lib": "static-1.981",
  "multi-currency-client-types": "static-1.3938",
  "object-builder-ui-client": "static-1.49779",
  "pipeline-validation-client-types": "static-1.4213",
  "property-value-citations": "static-1.3325",
  "pulse": "static-1.976",
  "smart-data-capture-core": "static-1.210",
  "smart-property-lib": "static-1.8386",
  "tiered-pricing": "static-1.2028",
  "topics-actions-lib": "static-1.516",
  "trial-components-library": "static-1.14180",
  "ui-addon-form-validation": "static-1.11330",
  "zustand": "static-1.86",
  "growth-onboarding-confetti": "static-1.3411",
  "growth-onboarding-next-action-utils": "static-1.2769",
  "navigation-components": "static-1.18912",
  "onboarding-tours-utils": "static-1.1265",
  "ui-shepherd-tracker": "static-1.7997",
  "ui-universal-auth": "static-1.9484",
  "getting-started-shared-tasks-store": "static-1.18449",
  "beacon-keepalive-queue": "static-1.50",
  "opentelemetry-web": "static-1.15",
  "hubspotter-http-shared-msw-handlers": "static-1.10691",
  "usage-tracker-session-replay": "static-1.5345",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "trellis-theming": "static-1.1319",
  "tanstack-virtual": "static-1.39",
  "audio-components": "static-1.6405",
  "FileManagerCore": "static-1.40097",
  "FileManagerImages": "static-1.37749",
  "video-components": "static-1.14227",
  "foundations-components-legacy": "static-1.1584",
  "purchase-motions-api": "static-1.6446",
  "signup-constants": "static-1.19699",
  "signup-ui-url-generator": "static-2.8406",
  "stylex-utils": "static-1.148",
  "usage-tracker-public": "static-1.7470",
  "reactive-lib": "static-1.1065",
  "simple-logging-lib": "static-1.3397",
  "chatspot-core": "static-1.23220",
  "growth-onboarding-feedback-components": "static-1.6931",
  "cms-field-types": "static-1.5158",
  "content-icons-ui": "static-1.2409",
  "integrations-lib": "static-1.17157",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.832",
  "breeze-engine-core": "static-1.1132",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1123",
  "customer-data-tracking": "static-1.7228",
  "products-iframe-lib": "static-1.8664",
  "products-ui-components-shared-msw-handlers": "static-1.11075",
  "restore-request-side-panel-lib": "static-1.1756",
  "onboarding-data-sync-lib": "static-1.2584",
  "hubspot-apollo-cache": "static-1.682",
  "calling-error-reporting": "static-1.31675",
  "shared-worker-versioning": "static-1.11387",
  "calling-usage-tracker": "static-1.6882",
  "voice-sms-access-library": "static-1.2153",
  "conversations-skeleton-state": "static-1.7593",
  "crm-index-associations-lib": "static-1.6790",
  "framework-data-schema-quick-fetch": "static-1.7144",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10776",
  "redux-toolkit": "static-1.79",
  "sales-views-client-types": "static-1.4602",
  "location-customization-utils-lib": "static-1.10187",
  "bark-lib": "static-1.16862",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.103",
  "crm-properties-common-lib": "static-1.6236",
  "react-codemirror": "static-1.10989",
  "fdsr-migration-layer": "static-1.358",
  "framework-builder-read-service-client": "static-1.4252",
  "persist-promise": "static-1.4048",
  "event-emitter": "static-1.1302",
  "bend-plugin-pulse": "static-1.479",
  "fast-json-patch": "static-1.71",
  "data-agent-kit": "static-1.713",
  "fsm": "static-1.4099",
  "policy-lib": "static-1.7151",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10839",
  "embedded-academy-lib": "static-1.15662",
  "hubs-service-types": "static-1.1606",
  "salesImages": "static-1.606",
  "growth-onboarding-next-action-components": "static-1.2797",
  "user-context-client": "static-1.4854",
  "nest": "static-1.583",
  "unified-auth-core-lib": "static-1.1280",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.483",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4876",
  "video-embed": "static-1.36717",
  "social-insights-client-types": "static-1.22718",
  "flux-actions": "static-1.374",
  "integrations-error-boundary-lib": "static-1.14572",
  "integrations-tracking-lib": "static-1.5955",
  "native-integrations-shared-strings": "static-1.8123",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10716",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.998",
  "InboxConnectUtils": "static-4.15635",
  "meetings-connect-utils-lib": "static-1.7957",
  "calling-orchestration-schema": "static-1.36930",
  "crm-record-cards-service-types": "static-1.3797",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16442",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.112",
  "trellis-story-utils": "static-1.4853",
  "storybook-react": "static-1.41",
  "academy-common-lib": "static-1.15122",
  "outpost": "static-1.4498",
  "universal-page-editor-lib": "static-1.3356",
  "adobe-sign-auth-lib": "static-1.547",
  "ads-unified-auth-lib": "static-1.1517",
  "custom-vendor-connection-lib": "static-1.48",
  "google-sheets-integration-lib": "static-1.1110",
  "microsoft-drive-auth-lib": "static-1.232",
  "surveymonkey-integration-lib": "static-1.576",
  "slack-ui-library": "static-1.10745",
  "hub-http-contrib": "static-1.3386",
  "ui-addon-sales-email": "static-1.5560",
  "academy-service-client": "static-1.4038",
  "croppie": "static-2.10",
  "final-form": "static-1.79",
  "SafeStorage": "static-1.4752",
  "trellis-ecosystem": "static-1.7686",
  "wootric-nps": "static-1.7231",
  "marketplace-ui-apps-core": "static-1.19350",
  "marketplace-ui-common": "static-1.20818",
  "developer-experience-shared-components": "static-1.10884",
  "immutable-less": "static-1.4997",
  "marketplace-ui-client-types": "static-1.18225",
  "ui-addon-integrations-directory-panel": "static-2.8373",
  "ui-extensibility-client-types": "static-1.4263",
  "ai-settings-ui-library": "static-1.8403",
  "nav-meta": "static-1.30549",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1197",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4579",
  "settings-ui-lib": "static-1.12870",
  "simple-data-table": "static-1.3593"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3183",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9998",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26270",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5936",
  "hs-test-utils": "/hs-test-utils/static-1.8383",
  "hub-http": "/hub-http/static-1.6558",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10693",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19059",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11838",
  "I18n": "/I18n/static-7.1680",
  "immutable": "/immutable/static-2.87",
  "jasmine-runner": "/jasmine-runner/static-1.6796",
  "payment-link-components": "/payment-link-components/static-1.24226",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.23",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7513",
  "quartz-core": "/quartz-core/static-1.6732",
  "quartz-i18n": "/quartz-i18n/static-1.1188",
  "react": "/react/static-7.196",
  "react-colorpicker": "/react-colorpicker/static-2.10559",
  "react-dlb": "/react-dlb/static-1.89",
  "react-utils": "/react-utils/static-2.5586",
  "reselect": "/reselect/static-3.13",
  "rich-text-lib": "/rich-text-lib/static-1.20368",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18437",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5975",
  "UIComponents": "/UIComponents/static-3.8784",
  "foundations-assets": "/foundations-assets/static-1.5232",
  "foundations-components": "/foundations-components/static-1.8559",
  "foundations-theming": "/foundations-theming/static-1.4822",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2538",
  "framer-motion": "/framer-motion/static-1.80",
  "metrics-js": "/metrics-js/static-1.9963",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1504",
  "quartz-config": "/quartz-config/static-1.1291",
  "quartz-routing": "/quartz-routing/static-1.943",
  "quick-fetch": "/quick-fetch/static-1.4158",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17070",
  "rpc-client-utils": "/rpc-client-utils/static-1.5012",
  "sanitize-text": "/sanitize-text/static-1.8503",
  "styled-components": "/styled-components/static-2.99",
  "tanstack-table": "/tanstack-table/static-1.62",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5103",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9878",
  "usage-tracker": "/usage-tracker/static-1.7659",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6076",
  "usage-tracker-core": "/usage-tracker-core/static-1.7509",
  "video-components-external": "/video-components-external/static-1.12225",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3790",
  "quartz-webpack": "/quartz-webpack/static-1.3737",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.591",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.90",
  "customer-data-objects": "/customer-data-objects/static-1.8044",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8265",
  "laboratory-lib": "/laboratory-lib/static-3.7499",
  "onboarding-scopes": "/onboarding-scopes/static-1.6798",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "ui-addon-opt": "/ui-addon-opt/static-4.8712",
  "HeadJS": "/HeadJS/static-2.804",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3494",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "hs-locale-management": "/hs-locale-management/static-1.325",
  "ts-schema": "/ts-schema/static-1.4324",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8258",
  "content-media-capture": "/content-media-capture/static-1.5530",
  "cssUtils": "/cssUtils/static-1.968",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10177",
  "file-manager-components": "/file-manager-components/static-1.24598",
  "HubStyle": "/HubStyle/static-2.12145",
  "knowledge-content-types": "/knowledge-content-types/static-1.8691",
  "PatternValidationJS": "/PatternValidationJS/static-1.3237",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.508",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10230",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11492",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9437",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10616",
  "video-data-lib": "/video-data-lib/static-1.35883",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4658",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6683",
  "customer-data-properties": "/customer-data-properties/static-1.52711",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19331",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5426",
  "onboarding-tours": "/onboarding-tours/static-1.17198",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8450",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3874",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9423",
  "user-context": "/user-context/static-1.5467",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.888",
  "hubspotter-http": "/hubspotter-http/static-1.4894",
  "icons": "/icons/static-2.695",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.584",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.498",
  "quartz-auth": "/quartz-auth/static-1.1188",
  "quartz-head": "/quartz-head/static-1.1178",
  "quartz-test": "/quartz-test/static-1.1188",
  "quartz-tracking": "/quartz-tracking/static-1.892",
  "trellis-components": "/trellis-components/static-1.2766",
  "ui-fonts": "/ui-fonts/static-1.1100",
  "usage-tracker-container": "/usage-tracker-container/static-1.7649",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9771",
  "data-token-picker": "/data-token-picker/static-1.16947",
  "FileManagerLib": "/FileManagerLib/static-1.40238",
  "property-translator": "/property-translator/static-1.5739",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6443",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6042",
  "react-create-root-preference": "/react-create-root-preference/static-1.79",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-virtualized": "/react-virtualized/static-2.108",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4828",
  "floating-ui": "/floating-ui/static-1.64",
  "react-aria": "/react-aria/static-1.73",
  "trellis-assets": "/trellis-assets/static-1.2747",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3305",
  "foundations-theming-base": "/foundations-theming-base/static-1.3807",
  "stylex": "/stylex/static-1.42",
  "interframe": "/interframe/static-3.5101",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6073",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.123",
  "web-vitals": "/web-vitals/static-1.16",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.422",
  "chirp-fetch": "/chirp-fetch/static-1.2242",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4818",
  "react-flip-move": "/react-flip-move/static-1.79",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5003",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13334",
  "content-media-compositions": "/content-media-compositions/static-2.17341",
  "idb-keyval": "/idb-keyval/static-1.52",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4492",
  "magpie-lib": "/magpie-lib/static-1.5788",
  "magpie-types": "/magpie-types/static-1.5248",
  "media-bridge-lib": "/media-bridge-lib/static-1.19465",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4078",
  "superstore": "/superstore/static-1.5105",
  "feedback-loader": "/feedback-loader/static-1.29871",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9807",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9048",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29388",
  "ContentUtils": "/ContentUtils/static-1.69211",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4771",
  "sassPrefix": "/sassPrefix/static-1.235",
  "react-dnd-compat": "/react-dnd-compat/static-1.4962",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1854",
  "copilot-toolkit": "/copilot-toolkit/static-1.11923",
  "atom": "/atom/static-1.5428",
  "avatar-components": "/avatar-components/static-1.2828",
  "navigation-messaging": "/navigation-messaging/static-1.8239",
  "redux-thunk": "/redux-thunk/static-2.81",
  "reference-resolvers": "/reference-resolvers/static-1.8527",
  "commerce-products-lib": "/commerce-products-lib/static-1.10630",
  "crm-message-bus": "/crm-message-bus/static-1.43856",
  "growth-data-modal": "/growth-data-modal/static-1.5954",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5223",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5413",
  "batch-promise": "/batch-promise/static-1.1891",
  "calling-global-api": "/calling-global-api/static-1.65759",
  "calling-internal-common": "/calling-internal-common/static-1.31668",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67141",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59435",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4047",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4594",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4378",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13377",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10020",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8444",
  "external-options-client-types": "/external-options-client-types/static-1.4371",
  "formula-editor": "/formula-editor/static-1.14831",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7239",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "hs-resources": "/hs-resources/static-1.539",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4457",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.981",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3938",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49779",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4213",
  "property-value-citations": "/property-value-citations/static-1.3325",
  "pulse": "/pulse/static-1.976",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.210",
  "smart-property-lib": "/smart-property-lib/static-1.8386",
  "tiered-pricing": "/tiered-pricing/static-1.2028",
  "topics-actions-lib": "/topics-actions-lib/static-1.516",
  "trial-components-library": "/trial-components-library/static-1.14180",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11330",
  "zustand": "/zustand/static-1.86",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3411",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2769",
  "navigation-components": "/navigation-components/static-1.18912",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1265",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7997",
  "ui-universal-auth": "/ui-universal-auth/static-1.9484",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18449",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.50",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10691",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5345",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "trellis-theming": "/trellis-theming/static-1.1319",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "audio-components": "/audio-components/static-1.6405",
  "FileManagerCore": "/FileManagerCore/static-1.40097",
  "FileManagerImages": "/FileManagerImages/static-1.37749",
  "video-components": "/video-components/static-1.14227",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1584",
  "purchase-motions-api": "/purchase-motions-api/static-1.6446",
  "signup-constants": "/signup-constants/static-1.19699",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8406",
  "stylex-utils": "/stylex-utils/static-1.148",
  "usage-tracker-public": "/usage-tracker-public/static-1.7470",
  "reactive-lib": "/reactive-lib/static-1.1065",
  "simple-logging-lib": "/simple-logging-lib/static-1.3397",
  "chatspot-core": "/chatspot-core/static-1.23220",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6931",
  "cms-field-types": "/cms-field-types/static-1.5158",
  "content-icons-ui": "/content-icons-ui/static-1.2409",
  "integrations-lib": "/integrations-lib/static-1.17157",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.832",
  "breeze-engine-core": "/breeze-engine-core/static-1.1132",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1123",
  "customer-data-tracking": "/customer-data-tracking/static-1.7228",
  "products-iframe-lib": "/products-iframe-lib/static-1.8664",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11075",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1756",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2584",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.682",
  "calling-error-reporting": "/calling-error-reporting/static-1.31675",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11387",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6882",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7593",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6790",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7144",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10776",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "sales-views-client-types": "/sales-views-client-types/static-1.4602",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10187",
  "bark-lib": "/bark-lib/static-1.16862",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.103",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6236",
  "react-codemirror": "/react-codemirror/static-1.10989",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.358",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4252",
  "persist-promise": "/persist-promise/static-1.4048",
  "event-emitter": "/event-emitter/static-1.1302",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.479",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "data-agent-kit": "/data-agent-kit/static-1.713",
  "fsm": "/fsm/static-1.4099",
  "policy-lib": "/policy-lib/static-1.7151",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10839",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15662",
  "hubs-service-types": "/hubs-service-types/static-1.1606",
  "salesImages": "/salesImages/static-1.606",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2797",
  "user-context-client": "/user-context-client/static-1.4854",
  "nest": "/nest/static-1.583",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1280",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.483",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4876",
  "video-embed": "/video-embed/static-1.36717",
  "social-insights-client-types": "/social-insights-client-types/static-1.22718",
  "flux-actions": "/flux-actions/static-1.374",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14572",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5955",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8123",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10716",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.998",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15635",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36930",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3797",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16442",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.112",
  "trellis-story-utils": "/trellis-story-utils/static-1.4853",
  "storybook-react": "/storybook-react/static-1.41",
  "academy-common-lib": "/academy-common-lib/static-1.15122",
  "outpost": "/outpost/static-1.4498",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3356",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.547",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1517",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.48",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1110",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.232",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.576",
  "slack-ui-library": "/slack-ui-library/static-1.10745",
  "hub-http-contrib": "/hub-http-contrib/static-1.3386",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5560",
  "academy-service-client": "/academy-service-client/static-1.4038",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.79",
  "SafeStorage": "/SafeStorage/static-1.4752",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7686",
  "wootric-nps": "/wootric-nps/static-1.7231",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19350",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20818",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10884",
  "immutable-less": "/immutable-less/static-1.4997",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18225",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8373",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4263",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8403",
  "nav-meta": "/nav-meta/static-1.30549",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1197",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4579",
  "settings-ui-lib": "/settings-ui-lib/static-1.12870",
  "simple-data-table": "/simple-data-table/static-1.3593"
}
};
